import './App.css';

import React, { useEffect } from 'react';

import Navbar from './components/Navbar';
import Banner from './img/erasmus-banner-projekt.png';
import BannerMobile from './img/erasmus-banner-projekt-mobile.png';

import SanMarino1 from './img/sanmarino/san_marino_5.jpg';
import Tyberiusz1 from './img/tyberiusz/339731727_621824943296754_3976686423984603631_n.jpg';
import Tyberiusz2 from './img/tyberiusz/340220609_953004922799556_8873225374493544035_n.jpg';
import useMobile from './hooks/useMobile';
import { useNavigate } from 'react-router-dom';

function Gallery(props: { images: { src: string, alt: string }[] }) {
    return (
        <div className='Gallery'>
            {props.images.map((image) => {
                return (
                    <div className='Gallery__image'>
                        <a href={image.src} target='_blank'><img src={image.src} alt={image.alt} width={'100%'} /></a>
                    </div>
                )
            })}
        </div>
    )
}

const tyberiusz_gallery = [
    {
        src: Tyberiusz1,
        alt: 'Tyberiusz 1'
    },
    {
        src: Tyberiusz2,
        alt: 'Tyberiusz 2'
    },
]

export default function App() {
    useEffect(() => {
        window.scrollTo({top: 0});
    }, [])
    const isMobile = useMobile();
    const navigate = useNavigate();
    return (
        <>
        <Navbar />
        <div className='App__container'>
            <div className='App'>
                <div className='App__banner'>
                    {!isMobile ? <img src={Banner} alt='Banner' width={'100%'}/> : <img src={BannerMobile} alt='Banner' width={'100%'}/>}
                </div>
                <div className='App__financing__container'>
                    <div className='App__financing__text'>
                        Dofinansowanie projektu z UE: 55 500 €
                    </div>
                </div>
                <div className='App__content'>
                    <div className='App__content__title'>
                        Cele projektu
                    </div>
                    <div className='App__content__text'>
                        <p>Realizacja stażu zawodowego w firmie europejskiej, co pozwoli uczestnikom na:</p>
                        <ul>
                            <li>wzrost praktycznych umiejętności zawodowych oraz weryfikację nabytej wiedzy w rzeczywistych warunkach pracy,</li>
                            <li>doskonalenie umiejętności posługiwania się językiem angielskim, także zawodowym, w bezpośrednich kontaktach z mieszkańcami Europy,</li>
                            <li>zdobycie praktycznego doświadczenia zawodowego za granicą,</li>
                            <li>poszerzenie wiedzy na temat innych kultur i krajów,</li>
                            <li>kształtowanie postaw proeuropejskich i społecznych,</li>
                            <li>nawiązywanie kontaktów międzynarodowych, aktywne uczestnictwo w życiu społ. i rozwój poczucia europejskiego obywatelstwa i tożsamości,</li>
                            <li>zapewnienie lepszego uznawania kompetencji zdobytych podczas nauki za granicą, dzięki certyfikatowi Europass, Indywidualnemu Wykazowi Osiągnięć (ECVET),</li>
                            <li>współpracę dyrekcji i nauczycieli przedmiotów zawodowych z przedstawicielami firm włoskich w zakresie ich oczekiwań, możliwości, programu praktyk i realizacji staży,</li>
                            <li>pogłębianie współpracy szkoły z lokalnym rynkiem pracy,</li>
                            <li>promocję szkoły i programu Erasmus Plus w środowisku zagranicznych i lokalnym.</li>
                        </ul>
                        <p>Uczestnicy projektu to 20 uczniów klas II, III i IV technikum (technik informatyk, technik rachunkowości i technik fotografii i multimediów) kształcący się w ZSP w Krośnie Odrzańskim. Po zajęciach przygotowawczych (językowych, kulturoznawczych i przygotowujących mentalnie do wyjazdu) uczestnicy wyjadą na 4 tygodniowy staż. We Włoszech poznają obyczaje, kulturę, rozwiną praktyczną znajomość języka angielskiego, a może nawet nauczą się włoskiego.</p> 
                    </div>
                    <div className='App__content__title'>
                        Aktualności
                    </div>
                    <div className='App__content__text'>
                    <p>Od listopada 2022 roku do marca 2023 przygotowywaliśmy się do wyjazdu do Włoch.</p>
                    <p>Intensywnie pracowaliśmy nad naszym angielskim, poznawaliśmy zasady funkcjonowania włoskich firm, uczyliśmy się rozwiazywania konfliktów, komunikacji itp.
                    Poznawaliśmy też kulturę Włoch, państwa o przebogatej historii  i osiągnięciach artystycznych.</p>

                    <p>Od 16 kwietnia 2023 roku jesteśmy w Rimini.
                    Nasze pierwsze dni tutaj upłynęły pod znakiem aklimatyzacji.
                    Wszystko wydawało się nie takie, hotel nie spełniał oczekiwań, posiłki odmienne niż w Polsce. Niektórzy stresowali się przed pierwszym spotkaniem z włoskim pracodawcą.</p>
                    <p>Zastanawiali się, jak poradzą sobie z porozumieniem, jakie dostaną zadania, jednak już po kilku dniach okazało się, że sprytniejsi koledzy objechali całe miasto autobusami i poznali różne ciekawe miejsca, najczęściej nieznane turystom.
                    Fotografowie odbyli pierwsze sesje wieczorne, a wysportowani chłopcy wczesnym rankiem pokonywali kilometry wzdłuż morza.</p>

                    <p>Pierwszego dnia pobytu, w poniedziałek nasza opiekunka, pani Karolina, zorganizowała nam krótką przechadzkę po starówce Rimini, zobaczyliśmy Tampio Malatestiano, czyli katedrę, nazwaną tak od imienia władcy tego miasta XV wieku, Sygismondo Pandolfo Malatesty, Łuk Augusta, Domus del Chirurgo - zabytki Rimini z początków naszej ery i czasów renesansu.
                    W czwartek wspólnie przespacerowaliśmy się mostem Tyberiusza, poznaliśmy San Guliano - zabytkową dzielnicę rybacką, której początki sięgają XI wieku. Dziś stanowi ona jedną z większych atrakcji turystycznych miasta. Urzekły nas murale i klimatyczne kawiarenki.</p>
                    
                    <p>Idąc wzdłuż portu jachtowego dotarliśmy do molo, gdzie  odpoczywaliśmy i podziwialiśmy piękno Adriatyku.</p>
                    <Gallery images={tyberiusz_gallery} />
                    <p>Kilkoro z nas wybrało się śladami Federico Felliniego na cmentarz w Rimini, gdzie znajduje się grób tego, urodzonego w Rimini, słynnego reżysera i jego nie mniej znanej żony, aktorki Gulietty Masiny.  Okazało się, że miejsce to bardzo różni się od naszych nekropoli, wielkością grobowców, które wskazują na ogromne znaczenie więzi rodzinnych dla  Włochów, potrzebę zachowania w pamięci bliskich zmarłych. Jeszcze bardziej zadziwiły nas „bloki” z urnami bądź trumnami.</p>
                    <p>W niedzielę 23 kwietnia 2023 roku wybraliśmy się do San Marino.</p>
                    <img className='App__content__image' src={SanMarino1} alt='San Marino 1' width={'100%'} style={{borderRadius: '8px'}} onClick={() => navigate('/wycieczki')} />
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}